module.exports = __webpack_public_path__ + "static/media/golfer-8-a.4d9c2289.png";